export default __webpack_public_path__ + "static/media/use-a-template.e2191e48.svg";